exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "button.btn {\n  display: inline-block;\n  text-align: center;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 26px;\n  letter-spacing: .08em;\n  white-space: normal;\n  text-transform: uppercase;\n  padding: 6px 28px;\n  vertical-align: middle;\n  touch-action: manipulation;\n  border-radius: 3px; }\n\nbutton:hover, button:focus {\n  background-color: #79a1bb;\n  color: #ffffff;\n  opacity: 0.8; }\n\nbutton.disabled, button[disabled] {\n  background: #79a1bb;\n  color: #ffffff;\n  opacity: .65; }\n  button.disabled:hover, button[disabled]:hover {\n    background: #79a1bb; }\n\nbutton.btn_primary {\n  background-color: #79a1bb;\n  margin: 0 0.5em;\n  color: #ffffff;\n  border-radius: 0px;\n  max-width: 300px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./node_modules/@mprep/shared/lib/angular/components/button/button.scss
// module id = N/Nj
// module chunks = 3